import { Asset, FieldLabels } from '@api/models'
import { Grid, Select, Text, Note, Spacer, Button } from '@components/common'
import { useStepperNav } from '@components/common/Stepper/Stepper'
import { ReactSelectOptions } from '@components/common/Select/Select.types'
import { useListSegmentsQuery } from '@api'
import { Controller, useFormContext } from 'react-hook-form'
import { useFormFieldProps } from '@hooks'

interface Props {
  fields: FieldLabels
}

const GLKeys = ({ fields }: Props) => {
  const {
    register,
    formState: { errors, isSubmitting },
    control,
  } = useFormContext<Asset>()

  const {
    data: segments,
    isLoading: isLoadingSegments,
    isSuccess: isSuccessGettingSegments,
  } = useListSegmentsQuery()

  const { getSelectProps } = useFormFieldProps<Asset>({
    isSubmitting,
    errors: errors as any,
    fields,
    register,
  })

  const tenKeys = [...Array(10).keys()]

  let segmentOptions: { [key: number]: ReactSelectOptions } = {}
  tenKeys.forEach(key => (segmentOptions[key] = []))

  if (isSuccessGettingSegments) {
    for (const segment of segments) {
      segmentOptions[segment.KY_NR].push({
        label: `${segment.KY_VALUE} (${segment.KY_DESC})`,
        value: segment.KY_VALUE,
      })
    }
  }

  const stepper = useStepperNav()

  function handleSkip() {
    tenKeys.forEach(i => {})
    stepper?.skip?.()
  }

  return (
    <Grid>
      <Grid.Item>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Text light small>
            Select the GL Keys for this asset. This step is optional and can be skipped.
          </Text>
          <Button
            appearance="text"
            size="compact"
            onClick={handleSkip}
            aria-label="Skip GL Keys"
          >
            Skip
          </Button>
        </div>
        {isLoadingSegments && (
          <>
            <Spacer y="mini" />
            <Note content={'Loading GL key options...'} />
          </>
        )}
      </Grid.Item>
      {tenKeys.map(i => (
        <Grid.Item key={i}>
          <Controller
            control={control}
            name={`AS_KEY${i}_ID` as any}
            render={({ field }) => (
              <Select
                {...getSelectProps(`AS_KEY${i}_ID` as any, field, segmentOptions[i])}
                isSearchable
              />
            )}
          />
        </Grid.Item>
      ))}
    </Grid>
  )
}

export default GLKeys
